module.exports = require("./lib/json3.js");


//////////////////
// WEBPACK FOOTER
// json3 (bower component)
// module id = 119
// module chunks = 1